import ConfigProvider from 'antd/es/config-provider';
import { useState } from 'react';
import { Locale } from 'antd/es/locale';
import { useMount } from 'ahooks';
import dayjs from 'dayjs';
import { localeMap, localeData } from '../locale/navigate';

export default function AntdConfigProvider(props: any) {
    const [locale, setLocal] = useState<Locale | undefined>((localeData as any)[props.defaultLocale || 'zh_CN']);

    useMount(async () => {
        const defaultLocale = props.defaultLocale || 'zh_CN';
        dayjs.locale((localeMap as any)[defaultLocale] || 'zh-cn');
    });
    return <ConfigProvider {...props} locale={locale} />;
}
